import { CalculatedOrderStatus, OrderState } from '../models';

declare global {
  interface Window {
    gtag: any;
    google: any;
  }
}

export enum GaEvent {
  OrderOpened = 'order_opened',
  PurchaseSuccess = 'purchase_success',
  FreeReschedule = 'free_reschedule',
  ChangeAddress = 'change_address',
}

export type OrderOpenedObject = {
  name: GaEvent.OrderOpened;
  shipper_name: string;
  shipper_id: string | number;
  shipper_order_code: string;
  order_id: number;
  order_state_calculated: CalculatedOrderStatus;
  milkman_order_state: OrderState;
  territory_id: number;
};

export type PurchaseSuccessObject = {
  name: GaEvent.PurchaseSuccess;
  products: string;
  price: string;
  shipperId: string;
  shipperName: string;
  territoryId: string;
  shipperOrderCode: string;
  orderStatus: string;
};

export type FreeRescheduleObject = {
  name: GaEvent.FreeReschedule;
  shipper_name: string;
  shipper_id: string | number;
  shipper_order_code: string;
  order_id: number;
  order_state_calculated: CalculatedOrderStatus;
  milkman_order_state: OrderState;
  territory_id: number;
  date: string;
  start_range?: string;
  end_range?: string;
};

export type ChangeAddressObject = {
  name: GaEvent.ChangeAddress;
  shipper_name: string;
  shipper_id: string | number;
  shipper_order_code: string;
  order_id: number;
  order_state_calculated: CalculatedOrderStatus;
  milkman_order_state: OrderState;
  territory_id: number;
};

type GaEventObject =
  | OrderOpenedObject
  | PurchaseSuccessObject
  | FreeRescheduleObject
  | ChangeAddressObject;

export const pushEvent = (
  event: GaEvent,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  { name, ...value }: GaEventObject
) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', event, value);
  }
};
